import React from "react";

const CreateMemberworkout = React.lazy(() => import("./CreateMemberworkout"));
const Index = React.lazy(() => import("./index"));
// const MemberworkoutDetails = React.lazy(() => import("./MemberworkoutDetails"));

export const memberWorkoutRoutes = [
	{
		path: "/admin/memberWorkouts",
		name: "Member Workouts",
		element: <Index />,
	},
	{
		path: "/admin/memberWorkouts/(create|update)/:id?",
		name: "Create Member workouts",
		element: <CreateMemberworkout />,
	},
	// {
	// 	path: "/admin/memberWorkouts/:id",
	// 	exact: true,
	// 	name: "Member Workout",
	// 	element:MemberworkoutDetails,
	// },
];
